export default function initializeModals() {
    new Modals();
}

class Modals {
    constructor() {
        this.modalBackground = document.querySelector('.modal-background');
        this.initCloseModal();
        this.initMoveModals();
        this.initOpenModal();
    }

    initOpenModal = () => {
        document.body.addEventListener('click', function (e) {
            const modalId = e.target.dataset?.modal_id || e.target.closest('[data-modal_id]')?.dataset?.modal_id;
            if (modalId) {
                e.preventDefault();
                const modal = document.getElementById(modalId);
                this.enableModal(modal);
                const focusId = e.target.dataset?.focus_id || e.target.closest('[data-focus_id]')?.dataset?.focus_id;
                if (focusId) {
                    setTimeout(() => {

                        document.getElementById(focusId).focus();
                    }, 100);
                }
            }
        }.bind(this));
    }

    initCloseModal = () => {
        if (this.modalBackground) {
            document.body.addEventListener('click', function (e) {
                if (e.target === this.modalBackground || e.target.classList.contains('modal-close') || e.target.classList.contains('modal-content')) {
                    this.disableModalBackground();
                    document.querySelectorAll('.modal-content--active').forEach((item) => {
                        this.disableModalContent(item);
                    }, this);

                    this.checkForRedirect();
                }
            }.bind(this));
        }
    }

    checkForRedirect = () => {
        const miniCartItems = document.querySelectorAll('.mini-cart-item');

        let redirect = true;
        miniCartItems.forEach((item) => {
            if (item.dataset.additProd === '0') {
                redirect = false;
            }
        })

        if (redirect) {
            if (MyScriptTranslations.shopUrl){
                window.location.href = MyScriptTranslations.shopUrl
            }else{
                // strona główna
                window.location.href = '/';
            }
        }
    }

    initMoveModals = () => {
        const modalsContainer = document.querySelector('.modal-popups');
        if (!modalsContainer) return;
        document.querySelectorAll('.modal-content:not(.modal-content--static)').forEach(function(item) {
            document.querySelector('.modal-popups').appendChild(item);
        }.bind(this));
    }


    enableModalBackground = () => {
        if (this.modalBackground) {
            document.body.style.top = `-${window.scrollY}px`;
            document.body.dataset.scroll_script = 'true';
            this.modalBackground.classList.add('modal-background--active');
            document.body.classList.add('modal-open');
            document.body.dispatchEvent(new CustomEvent('modal-open'));
        }
    }

    disableModalBackground = () => {
        if (this.modalBackground) {
            const scrollPosition = parseInt(document.body.style.top || '0', 10) * -1;
            this.modalBackground.classList.remove('modal-background--active');
            document.body.classList.remove('modal-open');
            document.body.style.top = '';
            document.body.dataset.scroll_script = 'true';
            window.scrollTo({top: scrollPosition, left: 0, behavior: 'instant'});
            document.body.dispatchEvent(new CustomEvent('modal-close'));

        }
    }

    toggleModalBackground = (force = null) => {
        if (this.modalBackground) {
            if (force === true || this.modalBackground.classList.contains('modal-background--active') === false) {
                this.enableModalBackground();
            } else if (force === false || this.modalBackground.classList.contains('modal-background--active') === true) {
                this.disableModalBackground();
            }
        }
    }

    enableModalContent = (element) => {
        if (!element || !element.classList.contains('modal-content')) return;
        element.classList.add('modal-content--active');
    }

    disableModalContent = (element) => {
        if (!element || !element.classList.contains('modal-content')) return;
        element.classList.remove('modal-content--active');
    }

    toggleModalContent = (element, force = null) => {
        if (!element || !element.classList.contains('modal-content')) return;
        if (force === null) {
            element.classList.toggle('modal-content--active');
        } else {
            element.classList.toggle('modal-content--active', force);
        }
    }

    enableModal = (element) => {
        this.enableModalBackground();
        this.enableModalContent(element);
    }

    disableModal = (element) => {
        this.disableModalBackground();
        this.disableModalContent(element);
    }

    toggleModal = (element, force = null) => {
        this.toggleModalBackground(force);
        this.toggleModalContent(element, force);
    }
}

